/* eslint-disable */
// ReSharper disable InconsistentNaming
// ReSharper disable StringLiteralWrongQuotes
/* tslint:disable:no-use-before-declare quotemark max-line-length */
export interface DataPlaneMerchant {
	Branding: Branding;
	MerchantSettings: DataPlaneMerchantSettings;
	DefaultSettings: DefaultSettings;
	CustomFields: ICustomField[];
	FundCustomFieldOrder: number;
	FundCustomLabel: string | null;
	DefaultFundKey: string | null;
	Funds: FundInfo[];
}
export interface FundInfo {
	FundName: string;
	FundKey: string;
	IsVisibleToMerchant: boolean;
}
export interface DefaultSettings {
	TermsAndConditionsUrl: string;
	PrivacyStatementUrl: string;
}
export interface DataPlaneMerchantSettings {
	RecurringFrequencies: string[];
	CryptoLink: string | null;
	OneTimeFutureGiftEnabled: boolean;
	PayerSpecifiedRecurringEndDateEnabled: boolean;
	PaymentLabel: string;
	PaymentAchMax?: number | null;
	PaymentMax: number;
	PaymentMin: number;
	PrivacyPolicy: string | null;
	RecurringByDefault: boolean;
	StockGivingLink: string | null;
	SupportsApplePay: boolean;
	SupportedCardBrands: string[];
	CardPreference: string | null;
	ApplePayMerchantName: string | null;
	ApplePayMerchantId: string | null;
	MerchantKey: string;
	SupportsAch: boolean;
	TermsAndConditions: string | null;
	CurrencyCode: string;
	CurrencySymbol: string;
	CountryCode: string;
	LegalName: string;
	SupportsMultiFundGiving: boolean;
	SupportsRockRmsSso: boolean;
}
export interface Branding {
	PrimaryColor: string;
	SecondaryColor: string;
	FaviconUrl: string | null;
}
export interface DropDownCustomField {
	Key: string;
	Label: string;
	IsRequired: boolean;
	Type: CustomFieldType.DropDown;
	Order: number;
	DefaultOptionValue: string | null;
	Options: DropDownCustomFieldOption[];
}
export interface DropDownCustomFieldOption {
	Label: string;
	Value: string;
}
export enum CustomFieldType {
	Unknown = 0, Text = 1, Number = 2, DropDown = 3,
}
export interface NumberCustomField {
	Key: string;
	Label: string;
	Placeholder: string;
	IsRequired: boolean;
	Type: CustomFieldType.Number;
	Order: number;
	MinLength: number;
	MaxLength: number;
}
export interface TextCustomField {
	Key: string;
	Label: string;
	Placeholder: string;
	IsRequired: boolean;
	Type: CustomFieldType.Text;
	Order: number;
	MinLength: number;
	MaxLength: number;
	Validation: string;
}
export type ICustomField = TextCustomField | NumberCustomField | DropDownCustomField;
/* tslint:enable:no-use-before-declare quotemark max-line-length */
// ReSharper restore InconsistentNaming
// ReSharper restore StringLiteralWrongQuotes
